import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var HeaderTable = /*#__PURE__*/function (_Vue) {
  function HeaderTable() {
    var _this;
    _classCallCheck(this, HeaderTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HeaderTable, [].concat(args));
    _defineProperty(_this, "label", void 0);
    return _this;
  }
  _inherits(HeaderTable, _Vue);
  return _createClass(HeaderTable);
}(Vue);
__decorate([Prop({
  default: ""
})], HeaderTable.prototype, "label", void 0);
HeaderTable = __decorate([Options({
  components: {}
})], HeaderTable);
export default HeaderTable;